// src/components/layout/FooterComponent.vue
<template>
  <footer class="border-t border-border bg-background">
    <div class="container mx-auto px-4 sm:px-6 max-w-7xl py-12 sm:py-16">
      <div class="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <!-- Brand -->
        <div class="sm:col-span-2 lg:col-span-1">
          <img src="/logo/applypa-logo.png" alt="Applypa" class="h-8 w-auto mb-4" />
          <p class="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Land your next client faster. Built for Upwork freelancers.
          </p>
          <div class="flex items-center gap-3 mt-6">
            <a
              href="https://web.facebook.com/profile.php?id=61592321341460"
              aria-label="Facebook"
              class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
            ><i class="fab fa-facebook-f text-xs"></i></a>
            <a
              href="https://www.threads.com/@appylpa"
              aria-label="Threads"
              class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
            ><i class="fab fa-threads text-xs"></i></a>
            <a
              href="https://www.tiktok.com/@applypa"
              aria-label="TikTok"
              class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
            ><i class="fab fa-tiktok text-xs"></i></a>
            <a
              href="https://www.instagram.com/appylpa/"
              aria-label="Instagram"
              class="inline-flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-colors"
            ><i class="fab fa-instagram text-xs"></i></a>
          </div>
        </div>

        <!-- For Freelancers -->
        <div>
          <h3 class="text-xs font-semibold uppercase tracking-widest text-foreground mb-4">For Freelancers</h3>
          <ul class="space-y-3">
            <li><router-link to="/job-filters" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Browse Jobs</router-link></li>
            <li v-if="isAdminUser"><router-link to="/employers" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Browse Employers</router-link></li>
            <li><router-link to="/subscription/plans" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</router-link></li>
          </ul>
        </div>

        <!-- Company -->
        <div>
          <h3 class="text-xs font-semibold uppercase tracking-widest text-foreground mb-4">Company</h3>
          <ul class="space-y-3">
            <li><router-link to="/contact" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact Us</router-link></li>
            <li><router-link to="/privacy" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</router-link></li>
            <li><router-link to="/terms" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Terms of Service</router-link></li>
            <li><router-link to="/refund-policy" class="text-sm text-muted-foreground hover:text-foreground transition-colors">Refund Policy</router-link></li>
          </ul>
        </div>
      </div>

      <!-- Bottom bar -->
      <div class="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
        <p class="text-xs text-muted-foreground">
          &copy; {{ new Date().getFullYear() }} Applypa. All rights reserved.
        </p>
        <p class="text-xs text-muted-foreground">Made for Upwork freelancers.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import authStore from "@/store/auth";

export default {
  name: "FooterComponent",
  setup() {
    const user = computed(() => authStore.state.user);

    // Check if user is admin
    const isAdminUser = computed(() => {
      return (
        user.value &&
        (user.value.is_superuser ||
          user.value.account_type === "admin" ||
          user.value.admin_profile)
      );
    });

    return {
      isAdminUser,
    };
  },
};
</script>
